import { getComposeEvent, getQuickComposeViewState } from 'owa-calendar-compose-store-manager';
import { CharmSelectionType } from 'owa-calendar-helpers-types/lib/ComposeTypes';
import { getCharmSelectionTypeName } from 'owa-calendar-helpers-types/lib/utils/getCharmSelectionTypeName';
import { logUsage } from 'owa-analytics';
import { orchestrator } from 'satcheljs';
import {
    updateCharmAndSelectionType,
    onCharmAndSelectionTypeChanged,
} from 'owa-calendar-compose-form-actions';
import {
    CHARMS_USAGE_AUTOSELECT_OVERRIDE_MANUAL,
    CHARMS_USAGE_SELECTION_TYPE,
    CHARMS_USAGE_SOURCE_QUICKCOMPOSE,
    charmsDatapoints,
} from 'owa-calendar-charms-store';

export default orchestrator(onCharmAndSelectionTypeChanged, actionMessage => {
    const event = getComposeEvent(actionMessage.formId);
    const viewState = getQuickComposeViewState(actionMessage.formId);
    let newIconId = actionMessage.iconId;
    let newSelectionType = actionMessage.charmSelection;

    if (
        !viewState ||
        !event ||
        (event.CharmId == newIconId && viewState.charmSelection == newSelectionType)
    ) {
        return;
    }

    // Log when the auto selected icon is changed manually.
    if (
        viewState.charmSelection == CharmSelectionType.Automatic &&
        newSelectionType == CharmSelectionType.Manual
    ) {
        const { customData } = charmsDatapoints.CharmsDatapoint.autotomanualdatapoint;
        logUsage(CHARMS_USAGE_AUTOSELECT_OVERRIDE_MANUAL, customData(event.CharmId, newIconId));
    }

    updateCharmAndSelectionType(actionMessage.formId, newIconId, newSelectionType);

    const { customData } = charmsDatapoints.CharmsDatapoint.charmselectiondatapoint;
    logUsage(
        CHARMS_USAGE_SELECTION_TYPE,
        customData(
            getCharmSelectionTypeName(newSelectionType),
            newIconId,
            CHARMS_USAGE_SOURCE_QUICKCOMPOSE
        )
    );
});

export { CharmSelectionType };
